import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {VatRate} from "../../models/vatRate";
import {VatRateService} from "../../services/vatRate.service";

@Injectable()
export class VatRatesResolve implements Resolve<VatRate[]> {
    constructor(private vatRateService: VatRateService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<VatRate[]> {
        return this.vatRateService.getAll();
    }
}
